import React from "react";
import Popup from "reactjs-popup";

import "./Modal.scss";

type Props = {
  header: string,
  message?: string,
  onClose: () => void,
  children?: React.ReactNode
}

const Modal : React.FC<Props> = ({ header, message, onClose, children }) => {
  return (
    <Popup modal closeOnDocumentClick open onClose={onClose}>
      <div className="modal">
        <a className="close" href="#close" onClick={onClose}>
          &times;
        </a>
        <div className="header">{header}</div>
        {message && <div className="content">{message}</div>}
        {children && children}
      </div>
    </Popup>
  );
};

export default Modal;
